import { createContext, useContext } from "react";
import CommonStore from "./commonstore";
import DrawResultStore from "./DrawResultStore";
import ModalStore from "./ModelStore";
import UserStore from "./userstore";

interface Store {
    drawResultStore: DrawResultStore;
    commonStore: CommonStore;
    userStore: UserStore;
    modalStore: ModalStore;
}

export const store: Store = {
    drawResultStore : new DrawResultStore(),
    commonStore: new  CommonStore(),
    userStore: new UserStore(),
    modalStore: new ModalStore()
}

export const StoreContext = createContext(store);

export function useStore(){
    return useContext(StoreContext);
}

